import { differenceInCalendarDays } from 'date-fns';
import { REMINDER_DAYS, type ClientTaskData, type ReminderDayType } from '@/types/clientTasksApiTypes';
import type { Nullable } from '@/types/common';

const REMINDER_DAY_VALUES: readonly ReminderDayType[] = Object.values(REMINDER_DAYS);

const isReminderDayType = (days: number): days is ReminderDayType =>
  REMINDER_DAY_VALUES.some((value) => value === days);

export function getReminderDaysFromTask(task: ClientTaskData): Nullable<ReminderDayType> {
  const explicitDays = task.reminder_days;
  if (explicitDays != null) {
    const normalized = Math.abs(explicitDays);
    if (isReminderDayType(normalized)) return normalized;
  }

  const triggerIso = task.remind_user_at ?? task.reminder?.trigger_at;
  if (!triggerIso || !task.deadline) return null;

  const deadline = new Date(task.deadline);
  const triggerAt = new Date(triggerIso);
  if (Number.isNaN(deadline.getTime()) || Number.isNaN(triggerAt.getTime())) return null;

  const daysBeforeDeadline = differenceInCalendarDays(deadline, triggerAt);
  return isReminderDayType(daysBeforeDeadline) ? daysBeforeDeadline : null;
}
